import { Box, Checkbox, FormControl } from '@primer/react';
import React, { useState } from 'react';
import { Controller, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { ComboboxNguonBietToi } from '../../../components/combobox-nguonbiettoi';
import TextInput from '../../../components/ui/text-input';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import FormBlock from './FormBlock';
import ComboboxQuanHe from '../../../components/combobox-quanhe/ComboboxQuanHe';
interface IThongTinLienHeProps {
    control: any,
    hocSinh: IHocSinh,
    setFormData: React.Dispatch<React.SetStateAction<IHocSinh>>,
    setValue: UseFormSetValue<IHocSinh>,
    generatedCode?: string,
    register: any,
    errors: any,
    formData: IHocSinh,
    trigger: UseFormTrigger<IHocSinh>,
    canEdit?: boolean
}
const ThongTinLienHe = (props: IThongTinLienHeProps) => {
    const { control, setFormData, hocSinh, setValue, generatedCode, register, errors, formData, trigger } = props;

    const [selectedProvince, setSelectedProvince] = useState<any>(
        hocSinh.dm_tinh_id || null
    );
    const [selectedDistrict, setSelectedDistrict] = useState<any>(
        hocSinh.dm_huyen_id || null
    );
    const [selectedCommune, setSelectedCommune] = useState<any>(
        hocSinh.dm_xa_id || null
    );
    const handleProvinceChange = (value: any) => {
        setSelectedProvince(value);
        setSelectedDistrict(null);
        setSelectedCommune(null);
        setFormData((prev) => ({
            ...prev,
            dm_tinh_id: value,
            dm_huyen_id: 0,
            dm_xa_id: 0,
        }));
    };
    const handleDistrictChange = (value: any) => {
        setSelectedDistrict(value);
        setSelectedCommune(null);
        setFormData((prev) => ({
            ...prev,
            dm_huyen_id: value,
            dm_xa_id: 0,
        }));
    };
    const handleCommuneChange = (value: any) => {
        setSelectedCommune(value);
        setFormData((prev) => ({
            ...prev,
            dm_xa_id: value,
        }));
    };
    return (
        <FormBlock caption="Thông tin liên hệ">
            <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4,1fr)" }}>
                <FormControl>
                    <FormControl.Label>Quan hệ</FormControl.Label>
                    <Controller
                        name="dm_quanhe_id"
                        control={control}
                        render={({ field }) => (
                            <>
                                <ComboboxQuanHe
                                    value={field.value}
                                    onValueChanged={(value) => {
                                        field.onChange(value);
                                        setFormData((prev) => ({
                                            ...prev,
                                            dm_quanhe_id: value,
                                        }));
                                    }}
                                />
                            </>
                        )}
                    />
                </FormControl>
                <FormControl>
                    <FormControl.Label>Họ tên</FormControl.Label>
                    <TextInput
                        block
                        name="ho_ten_lien_he"
                        register={register}
                        errors={errors}
                    />
                </FormControl>
                <FormControl>
                    <FormControl.Label>Điện thoại</FormControl.Label>
                    <TextInput
                        block
                        name="dien_thoai_lien_he"
                        register={register}
                        errors={errors}
                    />
                </FormControl>
                <FormControl>
                    <FormControl.Label>Email</FormControl.Label>
                    <TextInput
                        block
                        name="email_lien_he"
                        register={register}
                        errors={errors}
                    />
                </FormControl>
            </Box>
        </FormBlock>
    );
};

export default ThongTinLienHe;